// extracted by mini-css-extract-plugin
export var root = "generic-page-alt-cta-module--root--5db01";